import ContentLoader from 'react-content-loader';

export const InfoCardLoader = ({
  size,
  uniqueLoaderKey,
}: {
  size?: 'lg' | 'sm';
  uniqueLoaderKey: string;
}) => {
  return (
    <div>
      <ContentLoader
        uniqueKey={uniqueLoaderKey}
        width="100%"
        height="100%"
        backgroundColor="#e5e7eb"
        foregroundColor="#d1d5db"
        className={`h-[130px] min-h-[130px] w-full sm:h-[138px] sm:min-h-[138px] ${size === 'sm' ? 'md:h-[116px] md:min-h-[116px]' : 'md:h-[165px] md:min-h-[165px]'}`}
      >
        <rect x="0" y="0" rx="4" ry="4" width="100%" height="100%" />
      </ContentLoader>
    </div>
  );
};
